import {Modal} from 'react-bootstrap'
import styles from './style.css'

class ConfirmModal extends React.Component {
  render () {
    let {
      onHide,
      showModal,
      disableHideOnOuterModal,
      title,
      description,
      onConfirm,
      confirmTitle,
      cancelTitle,
      hideCancelButton,
      confirmClassName,
      baseColor
    } = this.props

    return (
      <Modal
        onHide={disableHideOnOuterModal ? function () { /* no op */ } : (onHide)}
        show={showModal}
        dialogClassName={`${styles.dialog} modal-dialog`}>
        <Modal.Header className={`${baseColor === 'danger' ? styles.danger : ''}`}>
          <button onClick={onHide}
            type='button'
            className='close'
            data-dismiss='modal'
            aria-label='Close'>
            <span aria-hidden='true'>
              &times;
            </span>
          </button>
          <Modal.Title className={styles['title-modal']}>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {description}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            {!hideCancelButton && <button
              type='button'
              className='btn btn-default'
              onClick={onHide}>
              {cancelTitle || 'Cancel'}
            </button>}
            <button
              type='button'
              className={`btn btn-primary ${confirmClassName} ${baseColor === 'danger' ? styles.danger : ''}`}
              onClick={onConfirm}>
              {confirmTitle || 'OK' }
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

ConfirmModal.propTypes = {
  onHide: React.PropTypes.func,
  disableHideOnOuterModal: React.PropTypes.bool,
  showModal: React.PropTypes.bool,
  title: React.PropTypes.string,
  description: React.PropTypes.string,
  onConfirm: React.PropTypes.func
}

export default ConfirmModal



// WEBPACK FOOTER //
// ./app/components/ConfirmModal/ConfirmModal.js